import { mapState } from 'vuex';
import { themesMixin, vuetifyColors } from '../../../utils/themes';
export default {
  name: 'NiotaClassicCommonN1Card',
  mixins: [themesMixin],
  props: {
    // items: {
    //   type: Array,
    //   required: false,
    // },
    icon: {
      type: String,
      required: true
    },
    header: {
      type: String,
      required: false,
      default: null
    },
    subHeader: {
      type: [String, Number],
      required: false,
      default: null
    },
    col: {
      type: Object,
      required: false,
      default: function () {
        return {};
      }
    }
  },
  data: function () {
    return {
      customColor: vuetifyColors['info']
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    backgroundColor() {
      return `background: linear-gradient(${this.vuetifyColorHex('info')})`;
    }
  },
  watch: {},
  methods: {}
};